import axios, { AxiosResponse } from 'axios';
import { ILogisticModel } from '../model/logistic.model';

export class LogisticApi {
  async downloadOrGenerateBP(logisticModel: ILogisticModel): Promise<AxiosResponse<any>> {
    return axios.post('/api/logistical/downloadOrGenerateBp', logisticModel);
  }

  async mobileAppleGeolocationCheckAvailability(imei: string, refProvider: any, externalRef?: any, claimNumber?: any): Promise<AxiosResponse<any>> {
    return axios.post('/api/geolocalisation/mobileAppleGeolocationCheckAvailability/', { imei, refProvider, externalRef, claimNumber });
  }

  async mobileAppleGeolocalise(imei: string, refProvider: any, externalRef?: any, claimNumber?: any): Promise<AxiosResponse<any>> {
    return axios.post('/api/geolocalisation/mobile-apple/', { imei, refProvider, externalRef, claimNumber });
  }

  async checkIfExistBonTransport(bonTransportData: any): Promise<AxiosResponse<any>> {
    return axios.post('/api/logistical/checkExistBonTransport', bonTransportData);
  }
}
